import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => {
  return {
    scheduleSessionGrid: {
      '&:last-child': {
        '& .contentBox': {
          borderBottom: 'none'
        },
      }
    },
    ScheduleDataWrapper: {
      marginBottom: pxToRem(64),
      [theme.breakpoints.down('md')]: {
        marginBottom: pxToRem(32),
      },
      [theme.breakpoints.down('sm')]: {
        marginBottom: pxToRem(24),
      },
    },
    root: {
      display: 'flex',
      width: '100%',
    },
    heading: {
      ...theme.palette.common.ellipsis(),
      marginBottom: pxToRem(20),
      width: '100%',
      '@media (max-width: 768px)': {
        marginBottom: pxToRem(14),
      },
    },
  };
});

export default useStyles;
